<!-- 方案 -->
<template>
  <div class="page">
    <!-- 横幅 -->
    <Banner></Banner>
    <!-- 重点方案 -->
    <MajorScheme></MajorScheme>
    <!-- 更多方案 -->
    <MoreScheme></MoreScheme>
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
import MajorScheme from "./components/MajorScheme.vue";
import MoreScheme from "./components/MoreScheme.vue";

export default {
  components: {
    Banner,
    MajorScheme,
    MoreScheme,
  }
};
</script>

<style lang="less" scoped>
</style>
